import axios from "@/plugins/axios";

let url = (data) => "/api/v1/expo/programs/${_program}/employees".interpolate(data);

export const employees = {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url(data)}/${data._id}`).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url(data)}/${data._id}`, data).then((result) => result.data);
    },
};

export default employees;
